"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var SIZE_BOARD = 4;
var board = _to_consumable_array(Array(SIZE_BOARD)).map(function() {
    return Array(SIZE_BOARD).fill(0);
});
var score = 0;
var isWin = false;
var cells = document.querySelectorAll(".field-cell");
var allowedKeys = [
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown"
];
var message = {
    messageStart: document.getElementById("message-start"),
    messageLose: document.getElementById("message-lose"),
    messageWin: document.getElementById("message-win")
};
var button = document.getElementById("start-button");
button.addEventListener("click", setGame);
function resetGame() {
    score = 0;
    document.querySelector(".game-score").innerText = score;
    board = _to_consumable_array(Array(SIZE_BOARD)).map(function() {
        return Array(SIZE_BOARD).fill(0);
    });
    for(var r = 0; r < SIZE_BOARD; r++){
        for(var c = 0; c < SIZE_BOARD; c++)if (board[r][c] === 0) {
            message.messageLose.classList.add("hidden");
            message.messageWin.classList.add("hidden");
        }
    }
}
function setGame() {
    resetGame();
    changeButton();
    addRandomField(board);
    addRandomField(board);
    drawTile(board, cells);
}
document.addEventListener("keyup", function(e) {
    if (!allowedKeys.includes(e.key) || isWin) return;
    var prevBoard = JSON.parse(JSON.stringify(board));
    switch(e.key){
        case "ArrowLeft":
            slideLeft();
            loseGameMessage();
            winGameMessage();
            break;
        case "ArrowRight":
            slideRight();
            loseGameMessage();
            winGameMessage();
            break;
        case "ArrowUp":
            slideUp();
            loseGameMessage();
            winGameMessage();
            break;
        case "ArrowDown":
            slideDown();
            loseGameMessage();
            winGameMessage();
            break;
        default:
            break;
    }
    document.querySelector(".game-score").innerText = score;
    var isSameBoard = isMoved(prevBoard);
    if (isSameBoard) {
        addRandomField(board);
        drawTile(board, cells);
    }
});
var isMoved = function(prevBoard) {
    for(var r = 0; r < SIZE_BOARD; r++)for(var c = 0; c < SIZE_BOARD; c++){
        if (prevBoard[r][c] !== board[r][c]) return true;
    }
    return false;
};
function deleteZero(row) {
    return row.filter(function(item) {
        return item !== 0;
    });
}
function slide(row) {
    var rowClear = deleteZero(row);
    var newRow = rowClear;
    for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
        newRow[i] *= 2;
        newRow[i + 1] = 0;
        score += newRow[i];
    }
    newRow = deleteZero(newRow);
    while(newRow.length < 4)newRow.push(0);
    return newRow;
}
function slideLeft() {
    for(var i = 0; i < SIZE_BOARD; i++)board[i] = slide(board[i]);
}
function slideRight() {
    for(var i = 0; i < SIZE_BOARD; i++){
        board[i].reverse();
        board[i] = slide(board[i]);
        board[i].reverse();
    }
}
function getItemsColumsBoard(matrix) {
    var columsItems = [];
    for(var r = 0; r < matrix.length; r++)for(var c = 0; c < matrix.length; c++)columsItems.push(matrix[c][r]);
    return columsItems;
}
function getColumsBoard(arr, siceCut) {
    var columsArr = [];
    for(var i = 0; i < arr.length; i += siceCut){
        var subarray = arr.slice(i, i + siceCut);
        columsArr.push(subarray);
    }
    return columsArr;
}
function slideUp() {
    var colums = getColumsBoard(getItemsColumsBoard(board), SIZE_BOARD);
    for(var r = 0; r < SIZE_BOARD; r++)colums[r] = slide(colums[r]);
    var rows = getColumsBoard(getItemsColumsBoard(colums), SIZE_BOARD);
    for(var r1 = 0; r1 < SIZE_BOARD; r1++)board[r1] = rows[r1];
}
function slideDown() {
    var colums = getColumsBoard(getItemsColumsBoard(board), SIZE_BOARD);
    for(var r = 0; r < SIZE_BOARD; r++){
        colums[r].reverse();
        colums[r] = slide(colums[r]);
        colums[r].reverse();
    }
    var rows = getColumsBoard(getItemsColumsBoard(colums), SIZE_BOARD);
    for(var r1 = 0; r1 < SIZE_BOARD; r1++)board[r1] = rows[r1];
}
function changeButton() {
    button.classList += " restart";
    button.innerText = "Restart";
    button.style = "border: 2px solid red; color: #776e65; outline: none;";
    message["messageStart"].classList.add("hidden");
}
function addRandomField(matrix) {
    // Находим все пустые ячейки в матрице
    var emptyCells = [];
    matrix.forEach(function(row, rowIndex) {
        row.forEach(function(value, colIndex) {
            if (value === 0) emptyCells.push({
                rowIndex: rowIndex,
                colIndex: colIndex
            });
        });
    });
    // Если есть пустые ячейки, выбираем случайную и добавляем 2 или 4
    if (emptyCells.length > 0) {
        var randomIndex = Math.floor(Math.random() * emptyCells.length);
        var randomCell = emptyCells[randomIndex];
        matrix[randomCell.rowIndex][randomCell.colIndex] = Math.random() < 0.9 ? 2 : 4;
    }
}
function drawTile(tiles, element) {
    tiles.forEach(function(row, rowInd) {
        row.forEach(function(value, colInd) {
            var cellIndex = rowInd * tiles.length + colInd;
            var cell = element[cellIndex];
            if (value > 0) {
                cell.textContent = value;
                cell.classList = "field-cell" + " field-cell--".concat(value);
            } else {
                cell.textContent = null;
                cell.classList = "field-cell";
            }
        });
    });
}
function winGameMessage() {
    board.forEach(function(row) {
        row.forEach(function(tile) {
            if (tile >= 2048) {
                isWin = true;
                message.messageWin.classList.remove("hidden");
            }
        });
    });
}
function loseGameMessage() {
    if (isBoardFull() && !canMakeMove()) message.messageLose.classList.remove("hidden");
}
function isBoardFull() {
    return board.every(function(row) {
        return row.every(function(tile) {
            return tile !== 0;
        });
    });
}
function canMakeMove() {
    for(var r = 0; r < SIZE_BOARD; r++)for(var c = 0; c < SIZE_BOARD; c++){
        var value = board[r][c];
        if (value !== 0) {
            if (r < 3 && value === board[r + 1][c]) return true;
            if (c < 3 && value === board[r][c + 1]) return true;
        }
    }
    return false;
}

//# sourceMappingURL=index.496d2700.js.map
